@if (this.PrintAllowed && !loading) {
  <div class="print-page-container">
    <div class="print-container">
      <!-- ✅ OPTIMIZED: Compressed company header -->
      <div class="company-header" style="position: relative;">
        @if (ActiveDocumentVersion) {
          <div
            style="position: absolute; right: 0; top: 0; font-size: 10px; text-align: right; line-height: 1.2;">
            <span>{{ActiveDocumentVersion.FormatNo}}, Rev No. {{ActiveDocumentVersion.VersionNo}}</span><br>
          </div>
        }
        <div class="company-name">{{this.Company.CompanyName}}</div>
        <div class="company-addresses">
          <span><b>Head Office:</b> {{this.Company.HeadOfficeAddress}}</span> |
          <span><b>Factory:</b> {{this.Company.FactoryAddress}}</span>
        </div>
      </div>
      <div class="outpass-number">
        <b>Software Generated Material Out Pass No.: {{printData.OutpassDetails.OutpassNumber}}</b>
      </div>
      <!-- ✅ OPTIMIZED: Compressed OutPass details section -->
      <div class="outpass-details">
        <table class="details-table">
          <tr>
            <td><b>OutPass To:</b></td>
            <td>{{printData.OutpassDetails.OutpassTo}}</td>
            <td><b>OutPass Date:</b></td>
            <td>{{printData.OutpassDetails.OutpassDate | DatetimeConverter}}</td>
          </tr>
          <tr>
            <td><b>OutPass Type:</b></td>
            <td>{{printData.OutpassDetails.OutpassType}}</td>
            <td><b>Purpose:</b></td>
            <td>{{printData.OutpassDetails.Purpose}}</td>
          </tr>
          <tr>
            <td><b>Status:</b></td>
            <td>{{printData.OutpassDetails.Status}}</td>
            @if (printData.OutpassDetails.ExpectedReturnDate) {
              <td><b>Expected Return:</b></td>
            }
            @if (printData.OutpassDetails.ExpectedReturnDate) {
              <td>{{printData.OutpassDetails.ExpectedReturnDate |
              DatetimeConverter}}</td>
            }
          </tr>
          <tr>
            <td><b>Remark:</b></td>
            <td colspan="3" [innerHTML]="printData.OutpassDetails.Remark"></td>
          </tr>
        </table>
      </div>
      <!-- ✅ NEW: Backend-processed unit groups with consolidated data -->
      @for (unitGroup of printData.UnitGroups; track unitGroup) {
        <div class="unit-group">
          @if (printData.UnitGroups.length > 1) {
            <div class="unit-header">
              <h4>Unit Type: {{unitGroup.UnitType}}</h4>
            </div>
          }
          <table class="items-table">
            <thead>
              <tr>
                <th style="width: 5%;">S.No</th>
                <th style="width: 35%;">Product Details</th>
                <th style="width: 10%;">Qty</th>
                <th style="width: 8%;">Unit</th>
                <th style="width: 12%;">Amount</th>
                <th style="width: 12%;">Total Amount</th>
                <th style="width: 18%;">Entry Details</th>
              </tr>
            </thead>
            <tbody>
              @for (product of unitGroup.Products; track product; let i = $index) {
                <tr>
                  <td>{{i+1}}</td>
                  <td>
                    <div class="product-name">{{ product.ProductName }}</div>
                    @if (product.PackagingBreakdown) {
                      <div class="product-details">
                        <small><strong>Packaging:</strong> {{ product.PackagingBreakdown }}</small>
                      </div>
                    }
                    <!-- ✅ NEW: Show batch numbers and item details -->
                    @if (product.Items && product.Items.length > 0) {
                      <div class="item-details">
                        @for (item of product.Items; track item) {
                          <div class="item-row">
                            <small>
                              <strong>Batch:</strong> {{ item.BatchNo || 'N/A' }} |
                              <strong>Location:</strong> {{ item.StoreName }}/{{ item.RackName }}
                              @if (item.EntryType === 'Barcode' && item.SerialNumbers && item.SerialNumbers.length > 0) {
                                <span>
                                  | <strong>Serials:</strong> {{ item.SerialNumbers.join(', ') }}
                                </span>
                              }
                            </small>
                          </div>
                        }
                      </div>
                    }
                  </td>
                  <td>{{ product.TotalQuantity | number:'1.2-2' }}</td>
                  <td>{{ unitGroup.UnitType }}</td>
                  <td>₹ {{ (product.TotalAmount / product.TotalQuantity) | number:'1.2-2' }}</td>
                  <td>₹ {{ product.TotalAmount | number:'1.2-2' }}</td>
                  <td>
                    <div class="entry-type-info">
                      @if (product.HasManual) {
                        <span>Manual</span>
                      }
                      @if (product.HasBarcode) {
                        <span>Barcode ({{product.LabelCount}})</span>
                      }
                    </div>
                    @if (product.HasManual && product.HasBarcode) {
                      <div>
                        <small>Mixed Entry</small>
                      </div>
                    }
                  </td>
                </tr>
              }
              <!-- Unit group totals -->
              <tr class="totals-row">
                <td colspan="2"><b>{{unitGroup.UnitType}} Total:</b></td>
                <td><b>{{ unitGroup.TotalQuantity | number:'1.2-2' }}</b></td>
                <td><b>{{ unitGroup.UnitType }}</b></td>
                <td></td>
                <td><b>₹ {{ unitGroup.TotalAmount | number:'1.2-2' }}</b></td>
                <td>
                  @if (unitGroup.PackagingBreakdown) {
                    <small>{{ unitGroup.PackagingBreakdown }}</small>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      }
      <!-- ✅ NEW: Summary section with backend-calculated totals -->
      @if (printData.Summary) {
        <div class="summary-section">
          <h4 style="margin: 0 0 10px 0; text-align: center; color: #1890ff;">OutPass Summary</h4>
          <table class="summary-table">
            <tr class="grand-total">
              <td><b>Grand Total Quantity:</b></td>
              <td><b>{{ printData.Summary.GrandTotalQuantity | number:'1.2-2' }}</b></td>
              <td><b>Grand Total Amount:</b></td>
              <td><b>₹ {{ printData.Summary.GrandTotalAmount | number:'1.2-2' }}</b></td>
            </tr>
            @if (printData.Summary.UnitsUsed && printData.Summary.UnitsUsed.length > 0) {
              <tr>
                <td><b>Units Used:</b></td>
                <td colspan="3">{{ printData.Summary.UnitsUsed.join(', ') }}</td>
              </tr>
            }
            @if (printData.Summary.OverallPackagingBreakdown) {
              <tr>
                <td><b>Total Packaging:</b></td>
                <td colspan="3">{{ printData.Summary.OverallPackagingBreakdown }}</td>
              </tr>
            }
          </table>
        </div>
      }
      <!-- ✅ NEW: Processing method information -->
      @if (printData.OutpassDetails.CreateMode && printData.OutpassDetails.CreateMode !== 'Manual') {
        <div class="processing-info"
          >
          <div class="processing-method">
            <strong>Processing Method:</strong> {{ printData.OutpassDetails.CreateMode }}
            @if (printData.OutpassDetails.CreateMode === 'Mixed') {
              <span> (Manual + Barcode)</span>
            }
            @if (printData.OutpassDetails.CreateMode === 'Barcode') {
              <span> (Barcode Only)</span>
            }
          </div>
        </div>
      }
      <!-- ✅ OPTIMIZED: Clean footer section -->
      <div class="footer">
        <table class="footer-table">
          <tr>
            <td class="prepared-by">
              <div><b>PREPARED BY:</b></div>
              <div class="signature-name">{{printData.OutpassDetails.AddedBy}}</div>
            </td>
            <td class="approved-by">
              <div><b>APPROVED BY:</b></div>
              @if (printData.OutpassDetails.ApprovedByName == null) {
                <div class="signature-space"></div>
              }
              @if (printData.OutpassDetails.ApprovedByName !== '') {
                <div class="signature-name">
                {{printData.OutpassDetails.ApprovedByName}}</div>
              }
              <div class="signature-label">Authorized Signatory</div>
            </td>
          </tr>
        </table>
        <app-print-footer [audience]="'external'"></app-print-footer>
      </div>
    </div>
  </div>
}

<!-- ✅ NEW: Loading state -->
@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner">Loading OutPass data...</div>
  </div>
}